export default {"src":"/_next/static/media/question-vector.0ba4b38e.svg","height":603,"width":681,"blurWidth":0,"blurHeight":0};